import { createRouter, createWebHistory } from 'vue-router'
import { appConfig } from '@/configs/appConfig'
import { useLanguageStore } from '@/store/language.js'
import { useAuthStore } from '@/store/auth.js'
import routes from '@/routes/index.js'
import { localePath } from '@/utils/localePath.js'
import { nuxtRoutes } from '@/configs/routes.js'

const router = createRouter({
  history: createWebHistory(),
  routes
})

let isRedirected = false

function externalRedirect(to, from, next) {
  if (isRedirected) return true

  const isMatched = nuxtRoutes.some((path) => {
    const sanitizedPath = to.path.replace(/^\/(en|de)/gm, '').replace(/\/$/, '') || '/'

    const pattern = path.replace('_slug', '[a-z0-9_-]+').replace('_token', '[a-zA-Z0-9_-]+')

    return sanitizedPath.match(new RegExp(`^${pattern}$`))
  })

  if (isMatched) {
    window.location.href = `${appConfig.redirectTargetDomain}${to.fullPath}`
    isRedirected = true

    return true
  }
}

router.beforeEach((to, from) => {
  const isExternalRedirected = externalRedirect(to, from)

  if (isExternalRedirected) {
    return false
  }

  const auth = useAuthStore()

  // Locale sync
  const languageStore = useLanguageStore()
  const locale = to.params.locale || appConfig.defaultLocale


  if (!to.meta?.pdf && auth.getLocale !== locale) {
    return localePath(to.fullPath, auth.getLocale)
  }

  if (languageStore.currentLocale !== locale) {
    languageStore.setLocale(locale)
  }

  // Auth redirect
  if (to.meta.requiresAuth && !auth.isAuthenticated()) {
    return localePath('/login', languageStore.currentLocale)
  }

  if (to.meta.requiresAuth === false && auth.isAuthenticated() && to.meta.layout !== 'empty') {
    return localePath('/', languageStore.currentLocale)
  }

  return true
})

const STALE_CHUNK_ERRORS = [
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
  'is not a valid JavaScript MIME type',
  'Couldn\'t resolve component'
]

router.onError((error, to) => {
  if (STALE_CHUNK_ERRORS.some(msg => error?.message?.includes(msg))) {
    window.location.assign(to.fullPath)
  }
})

export default router
